<template>
  <v-container>
    <v-container>
      <v-row>
        <v-col style="font-family: esquare;font-size: 1.8em; color: white; font-variant: small-caps;" cols="12">
          <h2 class="first">
            Hi,
          </h2>
          <h2 class="second">
            I'm Jesse,
          </h2>
          <h2 class="third">
            Web Developer
          </h2>
          <br />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row height="50%" align="center">
        <v-col style="font-family: esquare;font-size: 1em; color: white; font-variant: small-caps;" class="text-center">
          <h4 class="overline fourth grey--text">
            Full Stack Developer / JavaScript Expert / Freelancer
          </h4>
          <br />
          <v-btn color="grey lighten-3 overline" class="fifth" to="/contact">
            Contact
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'Home',
  components: {},
  mounted() {
    window.scrollTo(0,0)
    let tl = gsap.timeline()
    tl.from('.first', {y: -300, duration: 2, ease: 'expo.out', opacity: 0})
    tl.from('.second', {x: 700, duration: 2, ease: 'expo.out', opacity: 0}, '<1.2')
    tl.from('.third', {y: 700, duration: 2, ease: 'expo.out', opacity: 0}, '<1.2')
    tl.from('.fourth', {y: 10, duration: 1, ease: 'sine', opacity: 0}, '<.7')
    tl.from('.fifth', {duration: 1, ease: 'sine', opacity: 0}, '<.7')
  }
}
</script>

<style scoped>
</style>